<template>
  <div id="content">
    <div class="inner">
      <h1 v-translate>Reporty</h1>
    </div>
    <div class="inner_white">
      <ReportsListFilter
          :filterData="filterData"
          ref="reportslistfilterref"
          @onChange="onFilterChange"
      />
      <div class="table_overflow">
        <table class="vypis" ref="table_with_action_line">
          <thead>
          <tr>
            <th class="no_padding drag_drop"></th>
            <th class="no_padding checkbox"></th>
            <sorting-table-title
                v-for="title in sortingTableTitles"
                :key="title.key"
                :column="title.column"
                :sort="getActiveSort(title.column)"
                @changeSorting="changeSorting"
            >{{ title.name }}
            </sorting-table-title>
            <th class="no_padding"></th>
            <th class="no_padding last_data"></th>
          </tr>
          </thead>
          <reports-row v-for="entity in entities"
                       :item="entity"
                       :idReport="formFields.id_report"
                       :subscriberType="formFields.subscriber_type"
                       :key="entity.operator_id"
                       :selected-items="selectedEntities"
                       @input="select"
          ></reports-row>
        </table>
      </div>
      <list-action-line
          :entities="entities"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="totalCount"
          @select-all="toggleSelectAll"
          @run-multiple-action="runMultipleAction"
          @limit="setLimit"
          @offset="setOffset"
          ref="action_line"
      ></list-action-line>
    </div>
  </div>
</template>

<script>
import listActions from "@/components/mixins/list-actions";
import ReportsRow from "./ReportsRow";
import ReportsListFilter from "./ReportsListFilter";
import {downloadTableFile} from "@/utils/helpers"

export default {
  name: "Reports",
  components: {ReportsRow, ReportsListFilter},
  mixins: [listActions],
  data(){
    return {
      moduleName: 'reports',
      formFields: {
        id_report: null,
        category: null,
        limit: 50,
        subscriber_type: "t",
        sort: {
          column: 'ro.name',
          direction: 'asc'
        },
      },
      filterData: {},
      sortingTableTitles: [
        {key: 1, name: this.$gettext('Název operátora'), column: 'ro.name'},
        {key: 2, name: this.$gettext('Počet přiřazených balíčků'), column: 'channel_package_count'},
        {key: 3, name: this.$gettext('Počet odběratelů'), column: 'subscribers_count'},
        {key: 4, name: this.$gettext('Počet fakturovaných odběratelů'), column: 'paid_device_count'},
        {key: 5, name: this.$gettext('Počet firstscreen zařízení nad limit'), column: 'firstscreen_device_above_limit_count'},
      ],
    };
  },
  created(ReportsService) {
    if((!this.$_readActionAllowedAllOrOwnAndGlobal)){
      this.$router.push({name: 'reportsOperator', params: {id_operator: this.$_loggedUser_selectedOperatorId}});
    }

    this.entityService = ReportsService;
    this.entityService.getReportFormData()
      .then((data)=> {
        this.filterData = data;
        this.formFields.id_report = data["report_dates"][0]["id"];
        this.$refs.reportslistfilterref.setDefault(this.formFields);
      }).catch((e)=>{
      this.setErrorMessage(e['error_message'])
    })
  },

  computed: {
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},

        {value: 'csv_view', text: this.$gettext('Exportovat do CSV')},
        {value: 'xlsx_view', text: this.$gettext('Exportovat do XLSX')},
        {value: 'ods_view', text: this.$gettext('Exportovat do ODS')},

        {value: 'csv_summary', text: this.$gettext('Exportovat do CSV - souhrn')},
        {value: 'xlsx_summary', text: this.$gettext('Exportovat do XLSX - souhrn')},
        {value: 'ods_summary', text: this.$gettext('Exportovat do ODS - souhrn')},

        {value: 'csv_detail', text: this.$gettext('Exportovat do CSV - detailní report')},
        {value: 'xlsx_detail', text: this.$gettext('Exportovat do XLSX - detailní report')},
        {value: 'ods_detail', text: this.$gettext('Exportovat do ODS - detailní report')},

        {value: 'csv_vod', text: this.$gettext('Exportovat do CSV - videotéka')},
        {value: 'xlsx_vod', text: this.$gettext('Exportovat do XLSX - videotéka')},
        {value: 'ods_vod', text: this.$gettext('Exportovat do ODS - videotéka')},
      ]
    },
  },
  methods:{
    onFilterChange(filterData){
      this.formFields = {...this.formFields, ...filterData};
    },
    runMultipleAction(action) {
      let typeList = ['summary', 'detail', 'view', 'vod'];
      let actionData = action.split("_");
      let format = actionData[0];
      let type = actionData[1];
      if (typeList.includes(type)) {
        this.entityService.exportCsv({...this.formFields, ...{'id_operators': this.filteredSelectedEntities.join()}}, format, type)
            .then((response) => {
              this.setInfoMessageWithTimeout(this.$gettext('Stahování souboru...'))
              downloadTableFile(response, type, format)
            })
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/reports/ReportsList.vue